module.exports = __webpack_public_path__ + "startpage-746fed5a/sprachkenntnisse-lebenslauf-e09e8ed8a76218440c4a1f0e9cbdb223.jpg";